import { createSlice } from "@reduxjs/toolkit";
import { fetchTournaments } from "./tournaments.thunk";

/* =============================================================
   🧩 INITIAL STATE
============================================================= */
const initialState = {
  list: [],
  loading: false,
  error: null,
  lastFetched: null, // 🔥 for caching
};

/* =============================================================
   🧩 SLICE
============================================================= */
const tournamentsSlice = createSlice({
  name: "tournaments",
  initialState,
  reducers: {
    clearTournaments: (state) => {
      state.list = [];
      state.error = null;
      state.lastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTournaments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTournaments.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
        state.lastFetched = Date.now();
      })
      .addCase(fetchTournaments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearTournaments } = tournamentsSlice.actions;

export default tournamentsSlice.reducer;